import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleMinus, faCirclePlus } from '@fortawesome/pro-light-svg-icons';
import { PriceField2 } from 'components/UI';
import clsx from 'clsx';

interface QuantityAndPriceProps {
    quantity: number;
    amount: number;
    default?: string;
    onChangeQuantity: (quantity: number) => void;
    onChangeAmount: (amount?: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            width: '100%'
        },
        quantityContainer: {
            display: 'flex',
            width: 92,
            flexDirection: 'column',
            marginRight: 30
        },
        quantity: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
        },
        title: {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '16px',
            marginBottom: 36,
            [theme.breakpoints.up('md')]: {
                marginBottom: 38
            }
        },
        icon: {
            cursor: 'pointer',
            width: 16,
            height: 16
        },
        text: {
            fontWeight: 400,
            fontSize: 16,
            lineHeight: '16px'
        },
        field: {
            '& input': {
                paddingLeft: '0px !important',
                paddingRight: '0px !important',
                borderColor: '#d0d0d0 !important',
                height: '24px'
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #d0d0d0 !important'
            },
            '& .MuiOutlinedInput-adornedStart': {
                paddingLeft: '0px !important'
            }
        },
        priceContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        price: {
            marginBottom: '20px !important'
        }
    })
);

export const QuantityAndPrice: FunctionComponent<QuantityAndPriceProps> = props => {
    const classes = useStyles();

    const handleClickMinus = () => {
        if (props.quantity > 1) {
            props.onChangeQuantity(props.quantity - 1);
        }
    };

    return (
        <Box className={classes.container}>
            <Box className={classes.quantityContainer}>
                <Typography className={classes.title}>Quantity</Typography>
                <Box className={classes.quantity}>
                    <FontAwesomeIcon
                        icon={faCircleMinus}
                        className={classes.icon}
                        onClick={handleClickMinus}
                    />
                    <Typography className={classes.text}>{props.quantity}</Typography>
                    <FontAwesomeIcon
                        icon={faCirclePlus}
                        className={classes.icon}
                        onClick={() => props.onChangeQuantity(props.quantity + 1)}
                    />
                </Box>
            </Box>
            <Box className={classes.priceContainer}>
                <Typography className={clsx(classes.title, classes.price)}>Price</Typography>
                <PriceField2
                    value={props.amount}
                    scale={2}
                    precision={6}
                    default={props.default}
                    className={classes.field}
                    onChange={props.onChangeAmount}
                />
            </Box>
        </Box>
    );
};

export default QuantityAndPrice;
